export const RFO_OFFERING_WASTE = 'offeringWaste';
export const RFO_OFFERING_MATERIAL = 'offeringMaterial';
export const RFO_RECEIVING_MATERIAL = 'receivingMaterial';
export const RFO_OFFERING_SERVICES = 'offeringServices';
export const RFO_RECEIVING_SERVICES = 'receivingServices';
